// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import LinkedText from '../ui/LinkedText';

import * as serviceSelectors from './selectors';
import * as serviceActions from './actions';

import * as Formatters from '../ui/Formatters';
import * as MessageFormat from './MessageFormat';

const styles = theme => ({
  ...MessageFormat.styles(theme),
});


/*
 * Format for CS initiated request
 */
class CsFormat extends Component {
  render() {
    /* eslint-disable */
    const { classes, message } = this.props;

    return (
      <div className={classes.formatTop}>
        <div className={classes.messageSender}>
          Assist Request -  {message.taskStatus}
        </div>
        <div className={classes.taken}>
          {Formatters.formatDateTime(message.taken)}
        </div>
        <div className={classes.taken}>
          Reference ID: {message.messageId}
        </div>
        <div className={classes.taken}>
          Contact Description: {message.contactDescription}
        </div>

        <div className={classes.sectionHeader} style={{ whiteSpace: 'pre'}}>
          Request
        </div>
        
        <MuiCore.Divider/>

        <div className={classes.fieldData}>
          <LinkedText value={message.request}
                      onClick={this.props.openContactLink}/>          
        </div>
        
        
        <div className={classes.sectionHeader}>
          Request Details
        </div>
        
        <MuiCore.Divider/>
        
        <MuiCore.Grid container style={{paddingTop: 10}} spacing={1}>
          <MuiCore.Grid item xs={12}>
            <div className={classes.fieldLabel}>
              Agent
            </div>
            <div className={classes.fieldData}>
              {message.taskAgent}
            </div>
          </MuiCore.Grid>
          
          <MuiCore.Grid item xs={4}>
            <div className={classes.fieldLabel}>
              Submitted
            </div>
            <div className={classes.fieldData}>
              {Formatters.formatDateTime(message.taskStartTime)}
            </div>
          </MuiCore.Grid>
          
          <MuiCore.Grid item xs={4}>
            <div className={classes.fieldLabel}>
              Completed
            </div>
            <div className={classes.fieldData}>
              {Formatters.formatDateTime(message.taskEndTime)}
            </div>
          </MuiCore.Grid>
          
          <MuiCore.Grid item xs={4}>
            <div className={classes.fieldLabel}>
              Billable Agent Minutes
            </div>
            <div className={classes.fieldData}>
              {message.billableAgentMinutes}
            </div>
          </MuiCore.Grid>
        </MuiCore.Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return ({
    message : serviceSelectors.getMessage(state),
  });
};

const mapDispatchToProps = {
  openContactLink : serviceActions.openContactLink,
};

export default connect(mapStateToProps,
                       mapDispatchToProps)(withStyles(styles)(CsFormat));

